import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
import { motion } from 'framer-motion';
var SideModalOverlay = styled(motion.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  z-index: ", ";\n  background: ", ";\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  ", ";\n  justify-content: center;\n  align-items: center;\n  overscroll-behavior: none;\n  @media (min-width: ", "px) {\n    padding: ", "px;\n    max-height: unset;\n  }\n"], ["\n  display: flex;\n  z-index: ", ";\n  background: ", ";\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  ", ";\n  justify-content: center;\n  align-items: center;\n  overscroll-behavior: none;\n  @media (min-width: ", "px) {\n    padding: ", "px;\n    max-height: unset;\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.zIndex.modal;
}, function (props) {
  return props.overlayBackground;
}, function (props) {
  return props.maxHeight && "\n    max-height: ".concat(props.maxHeight, ";\n  ");
}, function (props) {
  var _a;

  return (_a = props.theme.breakpoints) === null || _a === void 0 ? void 0 : _a.xs;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.lg;
});
var SideModalContainer = styled(motion.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100vh;\n  @supports (height: 100dvh) {\n    height: 100dvh;\n  }\n  background: ", ";\n  width: 100%;\n  overscroll-behavior: none;\n  ", ";\n  position: absolute;\n  ", ";\n  top: 0;\n  z-index: ", ";\n  ", ";\n  overflow: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  @media (min-width: ", "px) {\n    max-height: unset;\n    width: ", "px;\n  }\n"], ["\n  height: 100vh;\n  @supports (height: 100dvh) {\n    height: 100dvh;\n  }\n  background: ", ";\n  width: 100%;\n  overscroll-behavior: none;\n  ", ";\n  position: absolute;\n  ", ";\n  top: 0;\n  z-index: ", ";\n  ", ";\n  overflow: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  @media (min-width: ", "px) {\n    max-height: unset;\n    width: ", "px;\n  }\n"])), function (props) {
  return props.background;
}, function (_a) {
  var maxWidth = _a.maxWidth;
  return maxWidth && "max-width:".concat(maxWidth);
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.slideFrom) === 'left' ? "left: 0px" : 'right: 0px';
}, function (props) {
  var _a;

  return (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.zIndex.modal;
}, function (props) {
  return props.maxHeight && "\n    max-height: ".concat(props.maxHeight, ";\n  ");
}, function (props) {
  var _a;

  return (_a = props.theme.breakpoints) === null || _a === void 0 ? void 0 : _a.sm;
}, function (props) {
  return props.width;
});
var templateObject_1, templateObject_2;
export { SideModalContainer, SideModalOverlay };